import { MigrationRegistry, type Migration } from './runner';

export * from './runner';

/**
 * 실제 migration 목록. 스키마 v1에서는 비어 있다.
 * 새 항목 추가 절차: DATA_SCHEMA 변경 문서 → 이 배열에 순수 함수 추가 → synthetic DB로 테스트 → 배포.
 */
export const MIGRATIONS: readonly Migration[] = [];

export const appMigrationRegistry = () => new MigrationRegistry(MIGRATIONS);
